module.exports = __webpack_public_path__ + "static/snowball-intro-phone-ff0f3781f119620c56f110eddb8f48be.gif";